export default __webpack_public_path__ + "static/media/gartic.1e190a78.png";